import * as React from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import logo from '../../logo.png';
import Box from '@mui/material/Box';
import { ApiContext } from '../../App';
import { useTranslation } from "react-i18next";

export default function Login(props) {

    const {authApi} = React.useContext(ApiContext)

    const logInURL = authApi.getLogInURL()

    React.useEffect(() => {
          window.location.replace(logInURL)
      }, []
    )

    return null

}
